import React, { useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { showAlert } from '../ui/dialog';
export function AlertaSucesso() {
    const navigate = useNavigate();
    const parametro = useParams();
    useEffect(() => {
        const destino = parametro.pagina;
        const texto = parametro.texto;
        navigate(`/${destino}`, { replace: true });
        setTimeout(() => showAlert({ title: "Sucesso", text: texto, icon: "success" }), 80);
    }, [])

    return (
        <></>
    );
}